<div
	class="border h-10 border-secondary-300 rounded-sm p-1.5 bg-standard flex gap-2 items-center overflow-y-hidden"
	[class.bg-secondary-100!]="disabled()"
	role="group"
>
	@for (button of buttons(); track $index) {
		@let isSelected = isValueSelected(button.value);
		<button
			[attr.data-cy]="'ui-button-toggle-' + $index"
			class="border border-transparent font-semibold flex-1 rounded-sm text-xs md:text-sm h-7 px-2 py-1 flex items-center justify-center transition focus-visible-border min-w-0"
			[class.bg-primary-200]="!button.disabled && isSelected"
			[class.text-secondary-400]="button.disabled"
			[class.cursor-not-allowed]="button.disabled"
			[class.text-secondary-800]="!button.disabled"
			[class.hover:border-secondary-300]="!isSelected && !button.disabled"
			(click)="onClick(button)"
			(keydown)="onKeyDown($event, $index)"
			(focus)="onFocus($index)"
			[tabindex]="getButtonTabIndex($index)"
			[disabled]="button.disabled"
		>
			<ng-container
				*ngTemplateOutlet="
					buttonToggleContentDirective()?.templateRef ?? null;
					context: { $implicit: button }
				"
			></ng-container>
			<ng-content></ng-content>
		</button>
	}
</div>
